import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { array } from 'io-ts/Decoder';
import { SagaIterator } from 'redux-saga';
import { decodeOrThrow } from 'src/io/utils/decodeOrThrow';
import { makeRestRequest } from 'src/modules/api/sagas/utils/makeRestRequest';
import { CARBON_INTENSITY } from 'src/modules/carbon-intensity/codecs/CarbonIntensity';
import { CarbonIntensity } from 'src/modules/carbon-intensity/types/CarbonIntensity';
import { call } from 'typed-redux-saga';

export function* loadCarbonIntensity(): SagaIterator<CarbonIntensity[]> {
  try {
    const { content } = yield* call(makeRestRequest, 'GET', '/carbon-intensity');
    return yield* call(decodeOrThrow, array(CARBON_INTENSITY), content);
  } catch (error) {
    throw new RuntimeError('Could not load carbon intensity', {}, NativeError.wrap(error));
  }
}
